import { IPublicationsReportRecord } from "../../../model/report/PublicationsReportRecord";
import { DateService } from "../../../service/DateService";

export interface TPublicationReportReportPresentationModel {
  version: number;
  submitDate: string;
  formalEvaluationStatus: string;
  formalEvaluationDate: string;
}

const PublicationsReportReportPresentationModel = (
  data: IPublicationsReportRecord
): TPublicationReportReportPresentationModel => {
  return {
    version: data.version,
    submitDate: data.submitDate
      ? DateService().formatDate(data.submitDate)
      : "",
    formalEvaluationStatus: data.formalEvaluationStatus,
    formalEvaluationDate: data.formalEvaluationDate
      ? DateService().formatDate(data.formalEvaluationDate)
      : ""
  };
};

export default PublicationsReportReportPresentationModel;
